var _defs, _path, _polygon, _polygon2, _polygon3, _path2, _path3, _path4, _polygon4, _path5, _path6, _path7, _path8, _path9, _polygon5, _polygon6, _polygon7, _path10, _path11, _path12, _path13, _path14, _polygon8, _polygon9, _polygon10, _rect, _rect2, _rect3, _path15, _path16, _path17, _path18, _polygon11, _path19, _path20, _polygon12, _path21, _path22, _path23, _path24, _polygon13, _polygon14, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVfsLogo25Clr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 693.2 190.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b {\n        fill: #01617f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M340.45.65l8.05,34.64,8.65-34.18.21-.34c.34-.24,7.46-.25,8.36-.14.3.04.61-.02.81.28l9.14,34.09,7.92-34.36h8.74l-11.71,45.66h-10.71c-1.95-8.15-4.52-16.18-6.44-24.33-.8-3.37-1.3-6.8-2.13-10.15-1.72,11.76-5.72,23.05-8.35,34.61h-10.04S331.16.65,331.16.65h9.28Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "553.12 .65 571.83 33.66 571.42 .65 579.88 .65 579.88 46.47 569.37 46.47 550.12 13.2 550.67 46.47 542.2 46.47 542.2 .65 553.12 .65"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "174.18 69.93 192.88 102.93 192.47 69.93 200.94 69.93 200.94 115.47 190.43 115.47 171.18 82.47 171.73 115.47 163.26 115.47 163.26 69.93 174.18 69.93"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "72.35 69.93 91.18 102.65 90.64 69.93 99.1 69.93 99.1 115.47 88.18 115.47 69.35 82.47 69.89 115.47 61.43 115.47 61.43 69.93 72.35 69.93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M178.49.18c13.22-1.4,22.35,5.31,23.81,18.61,1.78,16.25-7.7,29.59-24.97,28.22-25.28-2-23.27-44.24,1.16-46.83ZM179.85,7.82c-14.43,1.47-14.6,27.44-2.87,30.81,20.18,5.81,22.1-32.77,2.87-30.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M468.76,69.93c10.16-.05,29-3.33,29.75,11.59.38,7.56-4.14,11.83-11.05,13.5-.32.08-.49-.21-.41.41l14.2,20.04h-10.24l-12.74-18.36-.77-.45v18.82h-8.74v-45.55ZM477.5,77.02v12.95l.41.41h4.91c.34,0,2.55-.85,3.01-1.08,3.15-1.6,4.15-5.28,3.07-8.54-1.42-4.28-7.69-4.42-11.4-3.74Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M485.42,44.29c-13.37,4.73-32.55,4.71-37.54-11.46-3.28-10.62-.03-23.33,9.88-29.13,8.23-4.82,18.5-4.24,27.38-1.68l-1.37,7.89c-2.01-.46-3.95-1.13-5.99-1.5-6.35-1.15-13.33-.97-17.89,4.23-5.17,5.9-5.16,18.07.96,23.33,4.06,3.48,11.04,4.06,15.84,2.18v-15.68h8.74v21.82Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "259.64 21.11 274.51 .65 285.03 .65 268.4 22.65 285.57 46.47 274.51 46.47 259.64 24.65 259.64 46.06 259.23 46.47 250.9 46.47 250.9 .65 259.23 .65 259.64 1.06 259.64 21.11"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M396.69,46.47l15.86-45.39c.2-.42.53-.4.92-.45,2.71-.31,5.98.28,8.76,0l16.51,45.84h-9.15l-3.38-9.38-17.33-.12-3.59,9.51h-8.6ZM423.72,30.11l-6.42-19.37-6.42,19.37h12.83Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M110.02,115.47l15.86-45.11c.2-.42.53-.4.92-.45,2.71-.31,5.98.28,8.76,0l16.51,45.57h-9.56l-3.18-9.24h-17.25s-3.05,9.24-3.05,9.24h-9.01ZM137.05,99.38l-6.42-19.37-6.42,19.37h12.83Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M321.88,115.47h-9.42l-3.31-9.29-17.55.04-3.03,9.25h-8.74l16.23-45.57,9.57.29,16.24,45.28ZM294.03,99.38h12.83l-6.42-19.37-6.41,19.37Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M120.26.65l12.15,35.73c.23-1.9.8-3.77,1.36-5.6,2.6-8.46,5.76-17.28,8.74-25.64.53-1.48,1.06-3.11,1.78-4.49h8.6l-15.87,45.78-9.66.06L111.12.65h9.15Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M516.54,69.93l11.6,35.73,11.88-35.73h9.01l-15.86,45.11c-.2.42-.53.4-.92.45-2.79.32-6.17-.28-9.04,0l-16.23-45.56h9.56Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "526.91 .65 526.91 8.02 510.81 8.02 510.81 19.06 511.22 19.47 526.1 19.47 526.1 26.56 510.81 26.56 510.81 38.84 526.91 38.84 526.91 46.47 502.48 46.47 502.07 46.06 502.07 1.06 502.48 .65 526.91 .65"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "454.29 69.93 454.29 77.29 438.19 77.29 438.19 88.47 453.47 88.47 453.47 95.56 438.6 95.56 438.19 95.97 438.19 108.11 454.29 108.11 454.29 115.47 429.45 115.47 429.45 69.93 454.29 69.93"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "652.77 69.93 652.77 77.29 636.67 77.29 636.67 88.47 651.55 88.47 651.95 88.88 651.95 95.56 636.67 95.56 636.67 108.11 652.77 108.11 652.77 115.47 627.93 115.47 627.93 69.93 652.77 69.93"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M690.18,69.93l-.55,7.64c-4.89-1.49-16.81-2.77-15.84,5.32.26,2.18,2.56,3.49,4.32,4.41,7.77,4.1,17.18,5.27,14.68,17.28s-16.97,13.2-26.65,10.77c-.84-.59.39-6.76.01-8.06,4.67,1.19,15.66,3.52,17.48-2.85,1.97-6.89-7.63-8.19-11.94-10.46-11.48-6.05-8.53-20.75,3.47-23.91,5.06-1.33,9.9-.79,15.01-.14Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M413.61,69.93l-.27,7.63c-4.15-1.08-13.71-2.66-15.69,2.46-2.33,6.01,5.47,7.68,9.33,9.5,4.95,2.32,9.21,4.71,9.65,10.81,1.07,14.75-15.89,18.19-27.15,14.91l.39-7.94c5.36,1.87,19.86,3.35,17.34-6.28-1.33-5.09-14.91-5.3-18.1-13.01-2.06-4.98-.8-11.3,3.36-14.79,5.72-4.8,14.21-4.31,21.15-3.28Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M318.6,8.29c-4.84-1.36-16.81-2.78-15.84,5.32.5,4.17,8.86,6.1,12.11,7.81,6.07,3.22,8.38,7.93,6.66,14.74-2.85,11.3-17.29,12.07-26.67,10.03l.27-8.18c2.15.36,4.23,1.11,6.42,1.36,3.38.39,8.96.36,10.71-3.2,3.74-7.62-8.39-9.43-12.85-12.12-5.3-3.21-7.07-8.71-5.18-14.61,3.13-9.8,16.4-10.52,24.8-8.53l-.43,7.38Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M246.77,70.77l-.79,7.88c-4.51-1.01-9.48-2.1-14-.49-7.18,2.57-8.67,11.66-7.81,18.31,1.57,12.22,12.04,13.75,22.08,9.99l.69,7.65c-7.95,2.93-19.59,3.23-26.23-2.73-8.44-7.58-8.11-25.77-1.22-34.23s17.68-8.65,27.27-6.39Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M614.53,70.77l-.79,7.88c-5.29-1.17-11.28-2.46-16.19.59-5.52,3.43-6.48,11.85-5.57,17.74,1.84,11.93,12.26,13.12,22.04,9.48l.69,7.65c-8.65,3.15-21.28,3.28-27.71-4.25s-6.2-22.07-1.42-30.31c5.92-10.22,18.42-11.33,28.96-8.79Z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "24.3 69.93 24.3 77.29 8.74 77.29 8.74 89.29 23.48 89.29 23.48 96.38 8.74 96.38 8.74 115.47 0 115.47 0 69.93 24.3 69.93"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "224.14 .65 224.14 38.43 224.55 38.84 239.16 38.84 239.16 46.06 238.75 46.47 215.82 46.47 215.41 46.06 215.41 .65 224.14 .65"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "341.54 69.93 341.54 107.84 356.28 107.84 356.28 115.47 332.8 115.47 332.8 69.93 341.54 69.93"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 260.18,
    y: 69.93,
    width: 8.74,
    height: 45.55
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 559.95,
    y: 69.93,
    width: 8.74,
    height: 45.55
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 37.13,
    y: 69.93,
    width: 8.74,
    height: 45.55
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M382.73,167.33l6.05,18.78,6.52-18.65,3.85-.17,3.28,22.91c-.76-.14-2.95.39-3.23-.46l-2.64-18.37-6.54,18.84c-.9-.15-2.27.36-2.85-.45l-6.3-18.11-1.91,18.55h-3.28s3.28-22.91,3.28-22.91l3.78.04Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M418.19,167.09c5.92-.8,10.76,1.75,12.01,7.77,1.87,9.04-3.72,17.54-13.64,15.26-10.34-2.38-9.25-21.56,1.63-23.03ZM418.46,169.81c-7.22,1.22-7.78,15.47-.81,17.59,11.89,3.61,13.41-19.72.81-17.59Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M340.65,167.09c8.51-1.15,12.91,4.55,12.35,12.61-.52,7.45-6.78,12.43-14.2,10.37-10.2-2.82-8.81-21.54,1.85-22.98ZM340.92,169.81c-7.19,1.22-7.7,15.36-1.02,17.52,12.13,3.93,13.68-19.67,1.02-17.52Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M448.97,167.29c5.08.72,6.4,6.72,2.46,9.82-.58.46-1.41.55-1.77,1.09,6.45.94,5.83,9.16.27,11.32-.4.15-2.05.69-2.32.69h-8.05v-22.91c2.92.3,6.6-.4,9.42,0ZM442.55,177.11h4.23c.35,0,2.38-1.02,2.73-1.36,1.17-1.15,1.35-3.43.37-4.73-.28-.37-1.66-1.27-2.01-1.27h-5.32v7.36ZM442.55,187.48c3.69,1.5,10.79-1.16,7.98-5.92-.52-.89-2.55-1.99-3.47-1.99h-4.5v7.91Z"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "173.09 167.29 173.09 176.84 184.83 176.84 184.83 167.29 187.83 167.29 187.83 190.2 184.83 190.2 184.83 179.57 173.09 179.57 173.09 190.2 170.09 190.2 170.09 167.29 173.09 167.29"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M240.25,167.29v10.36l8.74-10.36h3.82l-9.29,11.05,9.84,11.86h-3.96c-.72,0-7.73-10.12-9.15-11.18v10.77c-.79.8-2.22.27-3.28.41v-22.91h3.28Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M271.1,167.29v2.45h-8.74v7.36h8.19v2.45h-8.19v7.91h8.33c.64.59.64,2.14,0,2.73h-11.19l-.41-.41v-22.5h12.01Z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "211.58 167.29 211.58 169.75 202.85 169.75 202.85 177.11 211.04 177.11 211.04 179.57 202.85 179.57 202.85 187.48 211.58 187.48 211.58 190.2 199.85 190.2 199.85 167.29 211.58 167.29"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M539.2,190.2l-3.16-.26c-.47-.67.13-6.73-.18-8.27-.71-3.49-5.14-9.61-6.55-13.37-.11-.29-.28-.55-.22-.87l3.42.13,5.32,11.18,5.23-11.41,3.23-.04-7.1,14.32v8.59Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M283.11,181.88l-7.09-14.19c-.08-.55.02-.35.4-.4.79-.1,2.62-.2,3.12.44l4.94,11.02,5.59-11.19,3.14-.27-7.1,14.59v8.32h-3v-8.32Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M328.98,167.29v2.45h-6.55v20.46c-1.05-.14-2.48.39-3.28-.41v-20.05h-6.55v-2.45h16.38Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M525.55,167.29v2.45h-6.55v20.46c-1.05-.14-2.48.39-3.28-.41v-20.05h-6.55v-2.45h16.38Z"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "162.44 167.29 162.44 169.75 155.89 169.75 155.89 190.2 152.89 190.2 152.89 170.16 152.48 169.75 146.06 169.75 146.06 167.29 162.44 167.29"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "481.87 167.29 481.87 187.48 490.06 187.48 490.06 190.2 478.86 190.2 478.86 167.29 481.87 167.29"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 463.58,
    y: 167.29,
    width: 3.28,
    height: 22.91
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 498.25,
    y: 167.29,
    width: 3.28,
    height: 22.91
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVfsLogo25Clr);
export default __webpack_public_path__ + "static/media/vfs-logo25_clr.8641ddb48265813d9f2b81a321b2ef25.svg";
export { ForwardRef as ReactComponent };